import classNames from 'classnames';
import React, { Fragment } from 'react';
import styles from "./Timeline.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function getTextWidth(text) {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (!context) {
    return 0;
  }
  context.font = getComputedStyle(document.body).font;
  return context.measureText(text).width;
}
export function Timeline({
  activeIndex,
  className,
  children
}) {
  const items = React.Children.toArray(children);
  const fixedItem = items.shift();
  const flexItems = items;
  const countFlexChildren = flexItems.length;
  const legLength = getTextWidth(fixedItem?.props.text) / Math.sqrt(2);
  function renderFixedItem() {
    let barWidth = 7;
    if (activeIndex > 0) {
      barWidth = legLength + 28;
    }
    return /*#__PURE__*/_jsxs("div", {
      className: styles.fixedItem,
      style: {
        maxWidth: `${legLength + 28}px`
      },
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.bar,
        style: {
          width: `${barWidth}px`
        }
      }), /*#__PURE__*/_jsxs("div", {
        className: classNames(styles.item, {
          [styles.active]: activeIndex >= 1
        }),
        style: {
          left: `${legLength}px`
        },
        children: [fixedItem, /*#__PURE__*/_jsx("div", {
          className: styles.dot
        })]
      })]
    });
  }
  function renderFlexItems() {
    return /*#__PURE__*/_jsx("div", {
      className: styles.flexItems,
      children: flexItems.map((item, i) => {
        const percentage = 100 - 100 / countFlexChildren * (i + 1);
        const offset = 28 + 7 / countFlexChildren * (i + 1);
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [activeIndex === i + 2 && /*#__PURE__*/_jsx("div", {
            className: styles.bar,
            style: {
              width: `${100 - percentage}%`
            }
          }), /*#__PURE__*/_jsxs("div", {
            className: classNames(styles.item, {
              [styles.active]: activeIndex >= i + 2
            }),
            style: {
              right: `calc(${percentage}% + ${offset}px)`
            },
            children: [item, /*#__PURE__*/_jsx("div", {
              className: styles.dot
            })]
          })]
        }, item.props.text);
      })
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: classNames(styles.timelineContainer, className),
    children: /*#__PURE__*/_jsxs("section", {
      className: styles.timeline,
      children: [renderFixedItem(), renderFlexItems()]
    })
  });
}